var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oauth-success"},[_c('img',{attrs:{"src":_vm.images.logo_square,"alt":"logo"}}),_c('h1',[_vm._v(_vm._s(_vm.$t("oauth.success")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }